import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/purchase-order",
    component: LayoutPage,
    children: [
      {
        path: "/purchase-order",
        name: "purchase-order-list",
        component: () =>
          import("@/views/PurchaseOrder/PurchaseOrderListPage.vue"),
        meta: {
          title: "Purchase Order List",
          titleLocalizationCode: "Purchase_Order_List",
          desc: "Purchase order list page",
          descLocalizationCode: "Purchase_Order_List_Page",
          sidebarElement: false,
          permissionCode: "PurchaseOrder.Read",
        },
      },
      {
        path: "/purchase-order/add",
        name: "purchase-order-add",
        component: () =>
          import("@/views/PurchaseOrder/PurchaseOrderAddPage.vue"),
        meta: {
          title: "Purchase Order Add",
          titleLocalizationCode: "Purchase_Order_Add",
          desc: "Purchase order add page",
          descLocalizationCode: "Purchase_Order_Add_Page",
          sidebarElement: false,
          permissionCode: "PurchaseOrder.Add",
        },
      },
    ],
  },
];
